import { useLayoutEffect, useRef, useState } from 'react';

export const useCommissionThresholdFieldOffset = ({ isEnabled }: { isEnabled: boolean }) => {
    const minThresholdRef = useRef<HTMLDivElement>(null);

    const computeThresholdFieldOffset = () => {
        if (minThresholdRef.current) {
            const computedStyle = getComputedStyle(minThresholdRef.current);

            const height = minThresholdRef.current.clientHeight;
            const marginTop = parseFloat(computedStyle.marginTop);

            return height + marginTop;
        }

        return 0;
    };
    const [thresholdFieldOffset, setThresholdFieldOffset] = useState(0);
    useLayoutEffect(() => {
        setThresholdFieldOffset(computeThresholdFieldOffset());
    }, [isEnabled]);

    return {
        minThresholdRef,
        thresholdFieldOffset,
    };
};
